export const LOAD_MORTALITY_BY_CAUSE_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_MORTALITY_BY_CAUSE_WIDGET_DATA_REQUEST";


